import * as z from 'zod/mini';
import { FACET_SEPARATOR, SORT_VALUES } from './constants';

const QueryParamsSchema = z.object({
  sort: z.catch(z._default(z.literal(SORT_VALUES), 'relevance'), 'relevance'),
  hideProductsYouOwn: z._default(z.catch(z.stringbool(), false), false),
  page: z.catch(z._default(z.coerce.number(), 0).check(z.minimum(0)), 0),
  query: z.optional(z.string()),
});

type QueryParams = z.infer<typeof QueryParamsSchema>;

function mapRefinementFromPathname(slugs: string) {
  return slugs
    .replace(/^\/|\/$/g, '') // no trailing slashes
    .replace(/\//g, FACET_SEPARATOR); // slashes -> separator
}

function createPathname(baseRoute: string, value: string) {
  return `${[baseRoute, ...value.split(FACET_SEPARATOR).filter(Boolean)].join('/')}/`;
}

export {
  createPathname,
  mapRefinementFromPathname,
  QueryParamsSchema,
  type QueryParams,
};
